module.exports = "54e2623814ea359514b9d0ab3382c09d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/lock.png
// module id = 42
// module chunks = 0